import { render, staticRenderFns } from "./TemuInventoryMgmt.vue?vue&type=template&id=72bece90"
import script from "./TemuInventoryMgmt.vue?vue&type=script&lang=js"
export * from "./TemuInventoryMgmt.vue?vue&type=script&lang=js"
import style0 from "./TemuInventoryMgmt.vue?vue&type=style&index=0&id=72bece90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports